import { Animation } from 'component/Carousel/util/animate'
import { makeAutoObservable } from 'mobx'

export class AnimationStore {
  private animation_id = 0
  private animation?: Animation

  constructor() {
    makeAutoObservable(this)
  }

  get busy(): boolean {
    return !!this.animation
  }

  next(next: Animation) {
    if (!this.keep(next)) this.start(next)
  }

  stop() {
    cancelAnimationFrame(this.animation_id)
    this.animation = undefined
  }

  keep(next: Animation) {
    const prev = this.animation
    const keep = prev && prev.to === next.to
    return keep
  }

  private start(an: Animation) {
    this.stop()
    this.animation = an

    const start = Date.now()
    const { from, to, duration, apply } = an

    const frame = () => {
      const passed = Math.min(duration, Date.now() - start)
      const x = duration > 0 ? passed / duration : 1
      const y = x * x * x // easeInCubic
      const base = to - from
      const value = from + base * y
      apply(value)
      if (passed < duration) {
        this.animation_id = requestAnimationFrame(frame)
      } else {
        this.animation = undefined
      }
    }

    this.animation_id = requestAnimationFrame(frame)
  }
}
